"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RichTextEditorTheme = exports.RichTextEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuill = _interopRequireDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
require("./styles.css");
var _utils = require("./utils.js");
require("react-quill/dist/quill.bubble.css");
var _CustomToolBar = _interopRequireDefault(require("./component/customToolBar/CustomToolBar.js"));
var _RichTextEditorStyledComponent = require("./RichTextEditorStyledComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let RichTextEditorTheme = exports.RichTextEditorTheme = /*#__PURE__*/function (RichTextEditorTheme) {
  RichTextEditorTheme["BUBBLE"] = "bubble";
  RichTextEditorTheme["SNOW"] = "snow";
  return RichTextEditorTheme;
}({});
const RichTextEditor = exports.RichTextEditor = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    isCustomToolbar = false,
    customChildren,
    height
  } = props;
  const childrenData = isCustomToolbar && !props.children ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomToolBar.default, {
    children: customChildren
  }) : props.children;
  const {
    customisedModules = isCustomToolbar ? _utils.CustomModules : _utils.modules,
    customisedFormats = isCustomToolbar ? _utils.CustomFormats : _utils.formats,
    placeholder = '',
    richTextEditorValue = '',
    onValueChange,
    readOnlyMode = false,
    theme = RichTextEditorTheme.SNOW,
    children = childrenData,
    hideBorder = false,
    borderWidth,
    borderStyle,
    borderColor,
    borderRadius,
    backgroundColor,
    disabledBgColor,
    textColor,
    padding,
    margin,
    boxShadow
  } = props;
  const onChange = value => {
    onValueChange?.(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RichTextEditorStyledComponent.RichTextEditorContainer, {
    className: `rich-text-editor ${hideBorder ? 'hide-border' : ''}`,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    disabledBgColor: disabledBgColor,
    textColor: textColor,
    padding: padding,
    margin: margin,
    boxShadow: boxShadow,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactQuill.default, Object.assign({
      theme: theme,
      ref: ref,
      modules: customisedModules,
      formats: customisedFormats,
      placeholder: placeholder,
      value: richTextEditorValue,
      tabIndex: 1,
      onChange: onChange,
      readOnly: readOnlyMode,
      className: `react-quill ${hideBorder ? 'hide-border' : ''}`
    }, height && {
      style: {
        height
      }
    })), children]
  });
});
var _default = exports.default = RichTextEditor;